import { panoramaClient, createGlobalConfig as _createGlobalConfig } from '@wix/panorama-client';
import { batchPlugin, environmentPlugin, sentryPlugin, topLevelPropsExtractorPlugin, pageParamsEnricherPlugin } from '@wix/panorama-client/plugins';
import { CLICKHOUSE_BATCH_REPORT_URL } from '@wix/panorama-common-shared/constants';
import { BATCH_THROTTLE_DURATION_MS, EXTRA_BASE_PARAMS } from './constants';
import { webReporter } from './reporter';
export const panoramaClientFactory = options => {
  const {
    baseParams,
    pluginParams,
    pageParams,
    data
  } = options;
  const {
    sentry,
    sentryDsn,
    sentryMain,
    sentryTransport
  } = pluginParams ?? {};
  const factory = panoramaClient({
    baseParams,
    data
  }).use(pageParamsEnricherPlugin(pageParams)).use(topLevelPropsExtractorPlugin(EXTRA_BASE_PARAMS)).use(environmentPlugin()).use(batchPlugin(BATCH_THROTTLE_DURATION_MS)).use(sentryPlugin({
    sentry,
    sentryDsn,
    sentryMain,
    sentryTransport
  })).withReporter(webReporter(CLICKHOUSE_BATCH_REPORT_URL));

  // @ts-expect-error
  factory.use = undefined;
  return factory;
};
export const createGlobalConfig = () => _createGlobalConfig();
//# sourceMappingURL=panorama-client-web.js.map